import { useEffect, useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

// Commentaire d'une opération, affiché sous sa description et modifiable d'un clic (même commentaire que dans Commentaires opérations)
export const CommentaireOperation = ({ id, valeur, onSaved, testId }) => {
  const [edition, setEdition] = useState(false);
  const [texte, setTexte] = useState(valeur);
  useEffect(() => { setTexte(valeur); }, [valeur]);
  const enregistrer = async () => {
    setEdition(false);
    const v = texte.trim();
    if (v === (valeur || "")) { return; }
    try {
      await api.put(`/transactions/${id}/commentaire`, { commentaire: v });
      toast.success("Commentaire enregistré et mémorisé");
      onSaved(id, v);
    } catch (e) { toast.error(errMsg(e)); setTexte(valeur); }
  };
  if (edition) {
    return (
      <Input autoFocus value={texte} onChange={(e) => setTexte(e.target.value)} onBlur={enregistrer} maxLength={2000}
        onKeyDown={(e) => { if (e.key === "Enter") { e.currentTarget.blur(); } if (e.key === "Escape") { setTexte(valeur); setEdition(false); } }}
        placeholder="Ajouter un commentaire…" className="mt-1 h-7 bg-white text-xs" data-testid={`${testId}-input`} />
    );
  }
  return (
    <button type="button" onClick={() => setEdition(true)} data-testid={testId}
      className={`mt-0.5 block text-left text-xs transition-colors ${texte ? "italic text-slate-600 hover:text-slate-900" : "flex items-center gap-1 text-slate-400 hover:text-emerald-700"}`}>
      {texte || <><MessageSquarePlus className="h-3 w-3" />Commentaire</>}
    </button>
  );
};
